// extracted by mini-css-extract-plugin
export default {"componentWrapper":"PageTitle_componentWrapper__NRMVP","backArrow":"PageTitle_backArrow__A3Yvn","title":"PageTitle_title__V-6Oq","thin":"PageTitle_thin__qoTFq"};